/**
 * This event listener forces iOS safari to display active states on links and buttons.
 * Otherwhise this state wouldn't be applied.
 */
document.addEventListener('touchstart', function() {}, false);



// WEBPACK FOOTER //
// ./vehi-industriepfad/assets/src/js/app/util/fixes/ios-active-state-fix/index.js